import styled from 'styled-components';

export const ContactFormAbsoluteWrapper = styled.div`
  position: absolute;
  min-width: 800px;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;

  @media (max-width: 830px) {
    width: 98%;
    min-width: 98%;
  }
`;
